import React from 'react';
import styles from './ContentDescription.module.css';

const ContentDescription=(props)=>{
	return(
		<div className={[styles.description,props.styles.description,(props.feature!==true?props.styles.ellipse:null)].join(' ')} dangerouslySetInnerHTML={{__html:props.description}}></div>
	);
};

export default ContentDescription;
